// Types
import { AdditionalDeliveryInfoProps } from './AdditionalDeliveryInfo.types';

// Components
import BodyText from '@components/body-text';
import Container from '@components/container';
import Heading from '@components/heading';

// Styles
import styles from './additional-delivery-info.scss';

const AdditionalDeliveryInfo = ({ text = '', title = '' }: AdditionalDeliveryInfoProps) =>
  text && (
    <Container className={styles.container} marginBottom="2">
      {title && (
        <Heading
          className={styles.title}
          label={title}
          marginBottom="1"
          tag="h4"
          testId="additional-delivery-info-title"
          type="xs"
        />
      )}
      <BodyText className={styles.text} maskContentSquare testId="additional-delivery-info-text">
        {Array.isArray(text) ? (
          text.map((line, index) => <span key={`gift-message-line${index + 1}`}>{line}</span>)
        ) : (
          <span>{text}</span>
        )}
      </BodyText>
    </Container>
  );

export default AdditionalDeliveryInfo;
